"use client";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { closeDialog, selectCurrentDialog } from "@/store/profileSlice";

export function KycDialogLoading() {
  const isMobile = useMediaQuery("(max-width:768px)");
  const dialog = useAppSelector(selectCurrentDialog);
  const dispatch = useAppDispatch();

  return (
    <Sheet
      open={dialog === "kycDetails"}
      onOpenChange={(val) => {
        if (!val) {
          dispatch(closeDialog());
        }
      }}
    >
      <SheetContent
        className="md:max-w-[500px] font-outfit px-4 lg:px-6 rounded-t-xl md:rounded-t-none overflow-y-scroll max-h-[70vh] md:max-h-screen"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
        side={isMobile ? "bottom" : "right"}
      >
        <SheetHeader>
          <SheetTitle className="text-center pb-10">KYC</SheetTitle>
          <SheetDescription className="sr-only">
            Upgrade your KYC
          </SheetDescription>
        </SheetHeader>

        <div className="flex flex-col gap-10">
          {/* Basic Wallet Skeleton */}
          <div className="flex flex-col gap-4 bg-primary-50/40 p-4 rounded-lg animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-48"></div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-32"></div>
              </div>
            </div>
            <div>
              <div className="h-5 bg-gray-200 rounded w-16 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          {/* Standard Wallet Skeleton */}
          <div className="flex flex-col gap-4 border border-border-300 p-4 rounded-lg animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-52"></div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-40"></div>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-56"></div>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-28"></div>
              </div>
            </div>
            <div>
              <div className="h-5 bg-gray-200 rounded w-16 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          {/* Platinum Wallet Skeleton */}
          <div className="flex flex-col gap-4 border border-border-300 p-4 rounded-lg animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-56"></div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-40"></div>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-36"></div>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="h-4 bg-gray-200 rounded w-32"></div>
              </div>
            </div>
            <div>
              <div className="h-5 bg-gray-200 rounded w-16 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-full"></div>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
